import { render, staticRenderFns } from "./xunfang.vue?vue&type=template&id=6463e47a"
import script from "./xunfang.vue?vue&type=script&lang=js"
export * from "./xunfang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports